module.exports = __webpack_public_path__ + "static/media/patient.9b9731b1.svg";